import { useSelector } from 'react-redux';
import { getBuyerOverridesIsLoading } from '../state/BuyerOverrides/selectors';
import { useSubtotals } from '../context/SubtotalsProvider';
import { usePaymentFormContext } from '../context/PaymentFormContext';
const useBuyerOverridesLoading = () => {
  const buyerOverridesLoading = useSelector(getBuyerOverridesIsLoading);
  const {
    loading: subtotalsLoading
  } = useSubtotals();
  const {
    checkoutSession
  } = usePaymentFormContext();
  const hasAtCheckoutTaxes = checkoutSession.get('isAutomatedSalesTaxEnabled');
  return buyerOverridesLoading || hasAtCheckoutTaxes && subtotalsLoading;
};
export default useBuyerOverridesLoading;